import { isClient } from '~/utils/envChecks'

export const LOCAL_STORAGE_HOTELS_RECENT_SEARCHES = 'hotels_recent_searches'

export const clearRecentSearchesFromLocalStorage = () => {
  if (isClient()) {
    localStorage.removeItem(LOCAL_STORAGE_HOTELS_RECENT_SEARCHES)
  }
}
